import logo from "../../../assets/doctio-logo-green.svg";
import cookies from "../../../assets/icons/cookies.svg";
import linkedin from "../../../assets/icons/linkedin.svg";
import facebook from "../../../assets/icons/facebook.svg";
import youtube from "../../../assets/icons/youtube.svg";

export default function Footer() {
  return (
    <footer className="bg-doctio-dark-green pb-6 pt-6 md:pt-16">
      <div className="mx-auto container w-full p-8 py-2 md:py-6 lg:py-8">
        <div className="md:flex md:justify-between py-10">
          <div className="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
            <div>
              <ul className="text-white font-medium">
                <li className="mb-8">
                  <a href="/privatlivspolitik" className="hover:underline">
                    Privatlivspolitik
                  </a>
                </li>
                <li>
                  <a
                    href="https://doctio.dk/brugerbetingelser"
                    className="hover:underline"
                  >
                    Brugerpolitik
                  </a>
                </li>

                <li className="block md:hidden mt-8">
                  <a href="/tutorials" className="hover:underline">
                    Tutorials / Doctio 101
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <ul className="text-white font-medium">
                <li className="mb-8">
                  <a href="/handelsbetingelser" className="hover:underline ">
                    Handelsbetingelser
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.doctio.dk/kontakt"
                    className="hover:underline"
                  >
                    Kontakt os
                  </a>
                </li>

                <li className="block md:hidden mt-8">
                  <a href="/priser" className="hover:underline">
                    Priser
                  </a>
                </li>
              </ul>
            </div>
            <div className="hidden md:block">
              <ul className="text-white  font-medium">
                <li className="mb-8">
                  <a href="/priser" className="hover:underline">
                    Priser
                  </a>
                </li>
                <li>
                  <a href="/tutorials" className="hover:underline">
                    Tutorials / Doctio 101
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="flex items-center border-t pt-0 md:pt-16 border-green-700 mt-6 flex-col md:flex-row justify-between">
          <a
            href="https://doctio.dk/"
            className="flex order-1 mb-5 md:mb-0 mt-10 md:mt-0 md:order-2 items-center"
          >
            <img src={logo} className="mr-0 md:mr-3" alt="Doctio Logo" />
          </a>
          <div className="mt-3 order-2 md:order-2 mb-2 md:mb-0 w-full">
            <ul className="list-none flex-wrap flex-col md:flex-row justify-center items-center flex align-center">
              <li className="text-dsm mb-6 md:mb-0 text-white sm:text-center ">
                Doctio ApS
              </li>

              <li className="text-dsm mb-6 items-center flex md:mb-0 text-white sm:text-center">
                <div className="inline-block h-[16px] w-[2px] mr-6 ml-6 bg-neutral-100 hidden md:block opacity-100"></div>
                Sankt Knuds Vej 6, 1.tv, 1903 Frederiksberg C
              </li>
              <li className="text-dsm mb-6 items-center flex md:mb-0 text-white sm:text-center ">
                <div className="inline-block h-[16px] w-[2px] mr-6 ml-6 hidden md:block bg-neutral-100 opacity-100"></div>
                CVR:{" "}
                <a href="https://datacvr.virk.dk/enhed/virksomhed/42937746?fritekst=doctio&sideIndex=0&size=10">
                  42937746
                </a>
              </li>
              <li className="text-dsm mb-6 items-center flex md:mb-0 text-white sm:text-center ">
                <div className="inline-block h-[16px] w-[2px] mr-6 ml-6 bg-neutral-100 hidden md:block opacity-100"></div>
                <a href="mailto:kontakt@doctio.dk">kontakt@doctio.dk</a>
              </li>
            </ul>
          </div>

          <div className="flex mt-2 order-3 space-x-5 justify-center sm:mt-0">
            <a href="/cookies" className="text-white hover:text-gray-900">
              <img src={cookies} alt="Cookies ikon" className="w-12 md:w-20" />
            </a>
            <a
              href="https://www.linkedin.com/company/doctio/?originalSubdomain=dk"
              className="text-white hover:text-gray-900"
            >
              <img
                src={linkedin}
                alt="Linkedin ikon"
                className="w-12 md:w-20"
              />
            </a>
            <a
              href="https://www.facebook.com/Doctiodk/"
              className="text-white hover:text-gray-900"
            >
              <img
                src={facebook}
                alt="Facebook ikon"
                className="w-12 md:w-20"
              />
            </a>
            <a
              href="https://www.youtube.com/channel/UCpCtLL6BUTUoryhsOrfpgVw"
              className="text-white hover:text-gray-900"
            >
              <img src={youtube} alt="Youtube ikon" className="w-12 md:w-20" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
